import {  ServiceResponseModule } from '@sdbn/common';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ApplicationClientCommonModule } from '@sdbn/common';
import { TransportInfoPanelModule } from '@sdbn/common';
import { TransportIssuesDialogComponent } from './component/transport-issues-dialog.component';
import { CommonTranslationModule } from '@sdbn/common';
import { TmcLegacyValidatorModule } from '@sdbn/tmc-common';
import { MatTooltipModule as MatTooltipModule } from '@angular/material/tooltip';
import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule as MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TransportInfoPanelModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
    ServiceResponseModule,
    TmcLegacyValidatorModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule

  ],
  declarations: [TransportIssuesDialogComponent],
  exports: []
})

export class TransportIssuesModule {
}
